var map = {
	"./biorific-shot.jpg": 100,
	"./blog-1.svg": 101,
	"./blog-cover.png": 102,
	"./cover.jpg": 103,
	"./ethics-in-tech-gayuru.jpeg": 104,
	"./fist-brown.png": 105,
	"./fist-light.png": 41,
	"./fist.png": 106,
	"./free-post.jpg": 107,
	"./free-post.png": 108,
	"./iPad.png": 109,
	"./mobile-marketing.jpg": 110,
	"./profilePic.jpg": 20,
	"./search-gayuru.png": 111,
	"./social-media-cover.jpg": 112,
	"./thumbs-brown.png": 113,
	"./thumbs-light.png": 114,
	"./thumbs.png": 42,
	"./updated-cover.jpg": 115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;